/** Max visible characters on discovery chips before ellipsis (Unicode ellipsis appended). */
export const MARKETPLACE_DISCOVERY_LABEL_MAX = 44;

export function truncateMarketplaceDiscoveryLabel(full: string): {
  label: string;
  truncated: boolean;
} {
  const t = full.trim();
  if (t.length <= MARKETPLACE_DISCOVERY_LABEL_MAX) {
    return { label: t, truncated: false };
  }
  return {
    label: `${t.slice(0, MARKETPLACE_DISCOVERY_LABEL_MAX)}…`,
    truncated: true,
  };
}

export type DiscoveryPromptCandidate = { text: string; score: number };

/**
 * Merges category-name and use-case strings by normalized key, keeping highest score
 * and first-seen casing for the text value.
 */
export function mergeMarketplaceDiscoveryPrompts(
  candidates: DiscoveryPromptCandidate[],
  limit: number,
): string[] {
  if (limit <= 0) return [];
  const byKey = new Map<string, { text: string; score: number }>();
  for (const { text, score } of candidates) {
    const trimmed = text.trim();
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    const prev = byKey.get(key);
    if (!prev || score > prev.score) {
      byKey.set(key, { text: trimmed, score });
    }
  }
  const merged = [...byKey.values()].sort(
    (a, b) => b.score - a.score || a.text.localeCompare(b.text),
  );
  return merged.slice(0, limit).map((x) => x.text);
}
